<template>
  <!-- 数据统计时间筛选组件 -->
  <div>
    <div class="info">
      <div>
        <span>已选服务商</span>
        <span>{{ facilitatorName }}</span>
        <el-button type="text" @click="editFacilitator">修改</el-button>
      </div>
      <div>
        <span>已选主体类型</span>
        <span>{{ statusType(subjectName) }}</span>
        <el-button type="text" @click="editSubjectType">修改</el-button>
      </div>
      <div>
        <span>创建时间</span>
        <span>{{ allData.subjectDataVO ? allData.subjectDataVO.createTime : '-' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    allData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },

  watch: {},
  computed: {
    subjectName() {
      return this.$route.query.subjectName;
    },
    facilitatorName() {
      return this.$route.query.facilitatorName;
    },
  },
  methods: {
    statusType(val) {
      if (val == 'SUBJECT_TYPE_INDIVIDUAL') {
        return '个体商户';
      }
      if (val == 'SUBJECT_TYPE_ENTERPRISE') {
        return '企业';
      }
      if (val == 'SUBJECT_TYPE_INSTITUTIONS') {
        return '党、政机关及事业单位';
      }
      if (val == 'SUBJECT_TYPE_OTHERS') {
        return '其他组织';
      }
    },
    editFacilitator() {
      this.$confirm('更改服务商后，将清空所有已填写的资料，请确认是否更改？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
      })
        .then(() => {
          // this.$message({
          //   type: 'success',
          //   message: '修改成功!',
          // });
          this.$router.push({
            path: '/merchants/facilitator',
            query: { type: 'add' },
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消修改',
          });
        });
    },
    editSubjectType() {
      this.$confirm('更改主体类型后，将清空所有已填写的资料，请确认是否更改？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
      })
        .then(() => {
          // this.$message({
          //   type: 'success',
          //   message: '修改成功!',
          // });
          this.$router.push({
            path: '/merchants/subjectType',
            query: { facilitatorName: this.$route.query.facilitatorName },
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消修改',
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 18px 30px 20px 30px;
  div span {
    font-size: 14px;
    color: #333;
    // font-weight: 500;
    margin-right: 14px;
  }
}
</style>
